/**
 * @fileoverview POST handler for the "/engagement/update_location_set/:location_set_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementUpdateLocationSetLocationSetIdCacheKeys } from "./constants";
import type {
  PostEngagementUpdateLocationSetLocationSetIdProps,
  EngagementUpdateLocationSetLocationSetIdResult,
} from "./types";

export const postEngagementUpdateLocationSetLocationSetId = reactQueryMutationAdapter(
  engagementUpdateLocationSetLocationSetIdCacheKeys,
  (
    props: PostEngagementUpdateLocationSetLocationSetIdProps
  ): Promise<EngagementUpdateLocationSetLocationSetIdResult> => {
    return fetch(`/engagement/update_location_set/${props.location_set_id}`, "POST", props);
  }
);
